var _circle, _path, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSuccess(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 185,
    height: 165,
    viewBox: "0 0 185 165",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 98,
    cy: 95,
    r: 69,
    stroke: "#0B735F",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75 99.9455L90.2784 111L122 79",
    stroke: "#0B735F",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 22.5,
    cy: 28.5,
    r: 3.5,
    fill: "#0B735F"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 20.5,
    cy: 96.5,
    r: 1.5,
    fill: "#0B735F"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 181.5,
    cy: 3.5,
    r: 3.5,
    fill: "#0B735F"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 146,
    cy: 23,
    r: 2,
    fill: "url(#paint0_linear_44_395)"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 164.5,
    cy: 49.5,
    r: 3.5,
    fill: "#0B735F"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 93.5,
    cy: 9.5,
    r: 2.5,
    fill: "#0B735F"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.5,
    cy: 69.5,
    r: 2.5,
    fill: "#0B735F"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_44_395",
    x1: 145.678,
    y1: 19.8,
    x2: 148.349,
    y2: 20.7059,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9881F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF774C"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.864a1e527b26475be1b34e440485d8ae.svg";
export { ForwardRef as ReactComponent };